import { createAPI } from '../../common'

export default {
  getpaperList: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0f60mjtuebub', 'get', config, vconfig),
  postPaperList: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0f60mjtuebub', 'post', config, vconfig),
  // 新建报纸
  postPaper: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0qbqfs0tbwf', 'post', config),
  // 删除报纸
  deletePaper: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0bdujpo0efmfuf', 'post', config),
  // 获取全部报纸
  getPaperAll: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0qbqfs0bmm', 'get', config),
  // 获取单个报纸
  getPaper: (config) => createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0qbqfs', 'get', config),
  // 报纸排序
  putPaperSort: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0qbqfs0tpsu', 'put', config),
  // 校验名称和code
  getPaperCheck: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0qbqfs0difdl', 'get', config),
  // 大样附件信息
  downloadInfo: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0mbzpvu0buubdinfou', 'get', config),
  // 下载单一文件
  getDownloadUrl: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0qbqfs0hfuEpxompbeVsm', 'get', config),
  // 下载大样图和pdf
  downloadLayout: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0mbzpvu0epxompbe', 'get', config),
  // 获取版面详情
  getPaperLayout: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0mbzpvu', 'get', config),
  // 获取见报成品图片的敏感信息
  getPhotoSensitiveTips: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0bsujdmf0tfotjujwfUjqt', 'get', config),
  // 获取稿件详情
  getPaperArticle: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0bsujdmf', 'get', config),
  // 获取预览详情
  getPreview: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0bsujdmf0qsfwjfx', 'get', config),
  // 获取报纸权限
  getPaperAuth: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0qbqfs0qfsnjttjpot', 'get', config),
  // 获取报纸权限---支持多个角色的权限获取
  getPaperProcsAuth: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0qbqfs0qfsnjttjpot0qspdt', 'get', config),
  // 获取流程记录
  getLogs: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0bdujpo0hfuMpht', 'get', config),
  // 获取报纸版面列表
  // 通用删除接口，包括报纸、版面、小样等
  paperDelete: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0bdujpo0efmfuf', 'post', config),
  paperRedraw: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0bdujpo0sfEsbxjoh', 'post', config),
  // 获取小样详情
  downloadArticleInfo: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0bsujdmf0qsfwjfx', 'get', config),
  // 下载小样详情---见报图片和见报稿件
  downloadArticle: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0bsujdmf0epxompbe', 'get', config),
  // 导出excel
  excelArticleExport: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0bsujdmf0fyqpsu', 'post', config),
  // 获取见报版面的相信信息
  getRcpaperLayoutInfo: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0mbzpvu', 'get', config),
  // 获取地区数据
  getCategoryGetCatList: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.jnbhf0dbuFyu0dbuMjtu', 'get', config, vconfig),
  // 版面标引修改
  editRcPaperLayoutInfo: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0mbzpvu0joefyjoh', 'post', config),
  // 手动加锁
  rcPaperPreAction: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0f60bdujpot0qsfbdujpo', 'get', config, {
      neverLoading: true
    }),
  // 手动解锁
  rcPaperPostAction: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0f60bdujpot0qptubdujpo', 'get', config, {
      neverLoading: true
    }),
  // 小样标引保存接口
  editRcPaperSubSample: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0bsujdmf0joefyjoh', 'post', config),
  // 获取稿件分类的分类树
  getCategoryGetCatTree: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0dbu0dbut', 'get', config),
  // 手动获取当前权限
  rcPaperGetActions: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0f60bdujpot', 'get', config, {
      neverLoading: true
    }),
  // 点击按钮解锁
  postE5Unlocker: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0f60bdujpot0vompdlfs',
      'post',
      config,
      vconfig
    ),
  // 修改图片的ai标签
  postUpdateImageTags: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0bsujdmf0vqebufJnbhfUbht',
      'post',
      config,
      vconfig
    ),
  // 保存热区
  postPaperHotareasaveSaveFXMap: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0mbzpvu0ipubsfb0tbwf',
      'post',
      config,
      vconfig
    ),
  // 删除热区接口
  getPaperHotareaDelHotArea: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0mbzpvu0ipubsfb0efmfuf',
      'get',
      config,
      vconfig
    ),
  /**
   * 获取操作人分组列表
   */
  getRcPaperUserlist: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0bdujpo0vtfsmjtu',
      'get',
      config,
      vconfig
    ),
  // 获取默认状态下的稿签
  getDefaultLabels: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0bsujdmf0joju', 'get', config, vconfig),
  postPaperAddSpecial: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0bsujdmf0beeTqfdjbm',
      'post',
      config,
      vconfig
    ),
  // 加入专题总接口---new
  postAddSpecial: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmtqfdjbm0tqfdjbm0bsujdmf0cbudi0bee0bsujdmf',
      'post',
      config,
      vconfig
    ),
  // 自动分类接口
  postAutoCat: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0gpvoefsBJ0bvupDbu',
      'post',
      config,
      vconfig
    )
  // // 小样列表
  // getLists: (config) =>
  //   createAPI('customEncryptApiName-1/0nfejby.qbqfs0bsujdmft0mjtut', 'post', config),
  // // 稿件状态下拉选
  // getStatusOptions: (config, vconfig = { neverLoading: true }) =>
  //   createAPI(
  //     '/mediax-paper/articles/query/status/options',
  //     'get',
  //     config,
  //     vconfig
  //   ),
  // // 根据栏目查询对应的版次列表

  // // 送制作
  // putMake: (config) =>
  //   createAPI('customEncryptApiName-1/0nfejby.qbqfs0bsujdmft0bdujpot0qipup0nblf', 'put', config)
}
